export default __webpack_public_path__ + "57ef569436936db1672f2f4e973918c9.svg";